import { render, staticRenderFns } from "./ConveyanceComponent.vue?vue&type=template&id=4005190e&scoped=true"
import script from "./ConveyanceComponent.vue?vue&type=script&lang=js"
export * from "./ConveyanceComponent.vue?vue&type=script&lang=js"
import style0 from "./ConveyanceComponent.vue?vue&type=style&index=0&id=4005190e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4005190e",
  null
  
)

export default component.exports